import { FilterType, Filter, FilterKey } from 'api-paths-cas';
import { IGetFilterGroupsProps } from '../../types';
import { hasPerm, P } from '@/utilities/roles/permissions';
import { UserRole } from '@/store/auth/types';

const NoneServices = 'None';

const getServicesOptions = (uniPartners: string[]) => {
  const uniServiceOptions = uniPartners.map(partner => ({
    label: partner,
    value: partner,
  }));
  return [
    ...uniServiceOptions,
    {
      label: 'None',
      value: NoneServices,
    },
  ];
};

const key = FilterKey.SERVICES;
export const getServicesFilter = ({ activeFilters, userRole, filterOptions }: IGetFilterGroupsProps): Filter | null => {
  const canFilterServices = hasPerm(userRole || UserRole.Unknown, P.FILTER_SERVICES);
  const serviceFilterOptions = filterOptions?.partner || [];
  if (!canFilterServices) {
    return null;
  }

  if (serviceFilterOptions.length === 0) {
    if ([UserRole.Uni, UserRole.UniAdmin, UserRole.UniLite, UserRole.UniSecure].includes(userRole!)) {
      return null;
    }
  }

  const parsedOptions = getServicesOptions(serviceFilterOptions);

  const filters = activeFilters[key] ?? [];
  const options = parsedOptions.map(({ label, value }) => {
    return {
      label,
      value,
      checked: filters.some(filter => filter === value),
    };
  });
  return {
    name: 'Services',
    key,
    type: FilterType.SELECT_MANY,
    showSearch: true,
    options: {
      SELECT_MANY: options,
    },
  };
};
